import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

export interface Activity {
  id: string;
  type: 'objet' | 'zone' | 'box' | 'site' | 'batiment' | 'piece';
  action: 'created' | 'updated' | 'deleted' | 'moved' | 'inventoried';
  entityId: string;
  entityName: string;
  userId: string;
  userName?: string;
  userEmail: string;
  details?: string;
  createdAt: string;
}

export const useActivities = (limit = 20) => {
  return useQuery({
    queryKey: ['activities', limit],
    queryFn: async (): Promise<Activity[]> => {
      const response = await apiClient.get('/objets/activities/recent', {
        params: { limit },
      });
      return response.data ?? [];
    },
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
};
